module.exports = "fragment CampaignFragment on Campaign {\n  __typename\n  id\n  name\n  isShareable\n  lines {\n    ...CampaignLineFragment\n  }\n}\n"